function validar_celular(num) {
  let expresion = /^0[\d]{9}$/;
  if (!expresion.test(num)) {
    return false;
  } else {
    return true;
  }
}
export default validar_celular;
